import axios from "axios";
import { errorMessageFromResponse } from "../constants/commonFunctions";
import { handleErrorMessage } from "./classes";
import { handleSuccessMessage } from "./success";

export function addConsultancyAndProject(projectsState, action) {
  return async (dispatch) => {
    let data = new FormData();
    data.append("name", projectsState.name);
    data.append("description", projectsState.description);
    data.append("start_date", projectsState.start_date);
    data.append("end_date", projectsState.end_date);
    data.append("profile", 4);
    if (projectsState.uploadImageFlag) {
      data.append(
        "image",
        projectsState.pictureAsFile,
        projectsState?.pictureAsFile?.name
      );
    }

    // validations
    if (projectsState.start_date == null || projectsState.end_date == null) {
      return {
        val: false,
        message: "Error adding project - Empty start date & end date",
      };
    }

    const headers = {
      "content-type": "multipart/form-data",
      Authorization: `Token ${localStorage.getItem("token")}`,
    };

    return axios
      .post(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/profile/project/`,
        data,
        { headers: headers }
      )
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          dispatch(handleSuccessMessage("Successfully added project"));
          dispatch({
            type: action,
            payload: res.data?.data,
          });
          return { val: true };
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
}

export function updateConsultancyAndProject(projectsState, action) {
  return async (dispatch) => {
    let data = new FormData();
    data.append("name", projectsState.name);
    data.append("description", projectsState.description);
    data.append("start_date", projectsState.start_date);
    data.append("end_date", projectsState.end_date);
    data.append(
      "profile",
      JSON.parse(localStorage.getItem("userData")).profile_id
    );
    if (projectsState.uploadImageFlag) {
      data.append(
        "image",
        projectsState.pictureAsFile,
        projectsState?.pictureAsFile?.name
      );
    }

    const headers = {
      "content-type": "multipart/form-data",
      Authorization: `Token ${localStorage.getItem("token")}`,
    };

    return axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}api/v1/profile/project/${projectsState?.id}/`,
        data,
        { headers: headers }
      )
      .then((res) => {
        if (res.status >= 200 && res.status < 300 && res.data.status == "1") {
          let value = Object.fromEntries(data.entries());
          if (projectsState.uploadImageFlag) {
            value = {
              ...value,
              id: projectsState.id,
              upload_img: URL.createObjectURL(projectsState.pictureAsFile),
            };
          } else {
            value = {
              ...value,
              id: projectsState.id,
              upload_img: projectsState.pictureAsFile,
            };
          }
          dispatch({
            type: action,
            payload: value,
          });
          dispatch(handleSuccessMessage("Updated Successfully"));
          return { val: true };
        }
      })
      .catch(async (error) => {
        dispatch(handleErrorMessage(errorMessageFromResponse(error)));
        return error;
      });
  };
}
